<template>
    <div class="no-message">
        <img class="" src="/static/img/empty-filter-result.png" />
        <!--<div>{{ $t("message.noMessage") }}</div>-->
        <div>
            <h2 v-if="Title">{{ Title }}</h2>
        </div>
        <div v-if="Desc">{{ Desc }}</div>
        <div v-if="newMail" class="new-mail" @click="openComposer()">
            <span class="new-mail-name">{{ $t("mail.createNewMail") }}</span>
            <span class="material-icons new-mail-icon">add</span>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";

export default {
    name: "NoMessage",
    props: ["Title", "Desc", "newMail"],
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapMutations({
            SELECTED_NEW_MAIL: "mail/SELECTED_NEW_MAIL",
        }),
        openComposer() {
            if (!this.checkPermission(PERMISSION_TYPES["mail.create"].tr.name)) {
                this.$message.error(this.$t("noPermission"));
                return;
            } else {
                this.SELECTED_NEW_MAIL(true);
                this.$emit("newComposer");
            }
        },
    },
};
</script>

<style scoped lang="scss">
.no-message {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    min-height: 300px;

    .new-mail {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .new-mail-name {
            margin-right: 10px;
            color: #ffa800;
        }

        .new-mail-icon {
            color: #ffa800;
        }
    }

    img {
        width: 200px;
    }

    div {
        margin-bottom: 5px;
        margin-top: 10px;
        color: #22272d;
        font-weight: 600;

        font-size: 18px;
        line-height: 23px;
        text-align: center;
    }
}
</style>
